
// import { createOrg } from '@/services'
import {
  fetchcloudDatas,
  getToken,
  saveCloud,
  stopCloud,
  loopCloud
} from '@/services/organization'
export default {
  namespaced: true,
  state: {
    submitting: false,
    cloudDatas: {},
    datasReady: false
  },
  mutations: {
    setSubmitting (state, type) {
      state.submitting = type
      state.datasReady = true
    },
    setCloudDatas (state, datas) {
      state.cloudDatas = datas
    }
  },
  actions: {
    // 获取私有云配置信息
    async fetchCloudDatas ({ commit }) {
      commit('setSubmitting', true)
      const chain = await fetchcloudDatas()
        .onSuccess(res => {
          commit('setCloudDatas', res)
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config({ tip: false })
      return chain
    },
    // 获取token
    async getToken ({ commit }) {
      commit('setSubmitting', true)
      const chain = await getToken()
        .onSuccess(res => {
          // commit('setCloudDatas', res)
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config({ tip: false })
      return chain
    },

    // 提交私有云配置
    async saveCloud ({ commit, dispatch }) {
      commit('setSubmitting', true)
      const chain = await saveCloud()
        .onSuccess(async () => {
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
      return chain
    },

    // 停止云服务
    async stopCloud ({ commit, dispatch }) {
      commit('setSubmitting', true)
      const chain = await stopCloud()
        .onSuccess(async () => {
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
      return chain
    },

    // 循环调取接口解密API
    async loopCloud ({ commit, dispatch }) {
      commit('setSubmitting', true)
      const chain = await loopCloud()
        .onSuccess(async () => {
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
      return chain
    }
  }
}
